import React from "react";

import { FormHookType } from "commons/types/form";

import { useBlockGroupContext } from "components/form/Blocks";

function useCheckSectionErrors<T>({ formHook }: { formHook: FormHookType<T> }) {
    const { setBlockWithErrors } = useBlockGroupContext();

    const { isValid, allErrorsVisibility } = formHook;

    React.useEffect(() => {
        if (isValid) {
            setBlockWithErrors(false);
        } else {
            if (allErrorsVisibility) {
                setBlockWithErrors(true);
            } else {
                setBlockWithErrors(false);
            }
        }
    }, [setBlockWithErrors, isValid, allErrorsVisibility]);
}

export default useCheckSectionErrors;
